import {ContentRoute} from "../../models/Route";
import ProcessoList from "./processoList";
import ProcessoNovo from "./processoNovo";
import ProcessoAlterar from "./processoAlterar";
import ProcessoTela from "./processoTela";
import CronogramaGeral from "./cronogramaGeral";
import DashboardProcessos from "./dashboard";
import MeusProcessos from "./meusProcessos";

// Processos do cliente (#480058). Tipos em ./modelo.

export const processos_content_routes: Array<ContentRoute> = [
    {
        'path': '/processos',
        'description': 'Processos',
        'exact': true,
        'component': ProcessoList,
        'menu': true
    },
    {
        'path': '/processos/meus',
        'description': 'Meus processos',
        'exact': true,
        'component': MeusProcessos,
        'menu': false
    },
    {
        'path': '/processos/novo',
        'description': 'Abrir processo',
        'exact': true,
        'component': ProcessoNovo,
        'menu': false
    },
    {
        'path': '/processos/cronograma',
        'description': 'Cronograma dos processos',
        'exact': true,
        'component': CronogramaGeral,
        'menu': false
    },
    {
        'path': '/processos/dashboard',
        'description': 'Dashboard de processos',
        'exact': true,
        'component': DashboardProcessos,
        'menu': false
    },
    {
        'path': '/processos/alterar/:id(\\d+)',
        'description': 'Alterar processo',
        'exact': true,
        'component': ProcessoAlterar,
        'menu': false
    },
    {
        'path': '/processos/:id(\\d+)',
        'description': 'Processo',
        'exact': true,
        'component': ProcessoTela,
        'menu': false
    },
];

export default processos_content_routes;
